import { makeAbsenceWarningRepository } from 'shared/infra/repositories';

import EvaluateAbsenceWarningUseCase from './implementations/EvaluateAbsenceWarningUseCase';

let instance: EvaluateAbsenceWarningUseCase | null = null;

export default function makeEvaluateAbsenceWarningUseCase() {
  if (!instance) {
    const repository = makeAbsenceWarningRepository();

    instance = new EvaluateAbsenceWarningUseCase(repository);
  }

  return instance;
}
